import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../components/layout/AppLayout';
import { PublicOnlyRoute, RequireAuth } from '../components/routing/RouteGuards';
import { SIGN_IN_PATH } from '../config/auth';
import { BookingSupportPage } from '../pages/BookingSupportPage';
import { SignInPage } from '../pages/SignInPage';
import { TourDetailsPage } from '../pages/TourDetailsPage';
import { ToursPage } from '../pages/ToursPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path={SIGN_IN_PATH} element={<PublicOnlyRoute />}>
        <Route index element={<SignInPage />} />
      </Route>
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate replace to="/tours" />} />
          <Route path="tours" element={<ToursPage />} />
          <Route path="tours/:id" element={<TourDetailsPage />} />
          <Route path="booking-support" element={<BookingSupportPage />} />
          <Route path="*" element={<Navigate replace to="/tours" />} />
        </Route>
      </Route>
    </Routes>
  );
}
